<template>
  <div>
    <DataTable
      :value="activityResults"
      :paginator="true"
      dataKey="contactId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedActivityResults"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} activityResults"
    >
      <template #empty> No results found. </template>
      <template #loading> Loading results data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="resultCode"
        header="Code"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.resultCode }}
          </div>
        </template>
      </Column>
      <Column
        field="resultDesc"
        header="Description"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.resultDesc }}
          </div>
        </template>
      </Column>
      <Column
        field="showsOn"
        header="Shows on"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ showsOnLabel(slotProps.data.showsOn) }}
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-info" 
              class="p-button-success p-mb-2"
              @click="editActivityResult(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <SettingDeleteConfirm
      :visible.sync="displayDeleteConfirm"
      :row="rowToDelete"
      list="activityResults"
      :label="rowToDelete ? String(rowToDelete.resultDesc || '') : ''"
      what="result"
      @deleted="row => $emit('deleted', row)"
    />
  </div>
</template>

<script>
import { showsOnLabel } from '../../activityKind.js'
import PermissionMixin from '../../PermissionMixin.vue'
import SettingDeleteConfirm from '../SettingDeleteConfirm.vue'
export default {
  mixins: [PermissionMixin],
  components: { SettingDeleteConfirm },
  props: [
    'activityResults',
    'loading'
  ],
  data: () => ({
    rowToDelete: null,
    displayDeleteConfirm: false,
    selectedActivityResults: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    showsOnLabel,
    getButtons(data) {
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteActivityResult(data)
            }
          }
        )
      }
      return buttons
    },
    // RT1: ask, then delete (SettingDeleteConfirm); it used to do nothing
    deleteActivityResult(row) {
      this.rowToDelete = row
      this.displayDeleteConfirm = true
    },
    editActivityResult(activityResult) {
      this.$emit('edit-activity-result', activityResult)
    }
  }
}
</script>

<style>

</style>